import React from 'react';
import { useQuery } from 'react-query';
import { FiPlus, FiEdit, FiTrash2 } from 'react-icons/fi';
import { classesService } from '../services/api';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ClasseModal from '../components/ClasseModal';
// eslint-disable-next-line no-unused-vars
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';
import ResponsiveDataList from '../components/common/ResponsiveDataList';
import MobileCard from '../components/common/MobileCard';

const Classes = () => {
 // const { user: _user } = useAuth(); // Préfixe _ pour indiquer variable intentionnellement inutilisée
  const { data: classes, isLoading, refetch } = useQuery(
    'classes',
    () => classesService.getAll(),
    {
      onError: (error) => {
        toast.error('Erreur lors du chargement des classes');
      }
    }
  );

const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: 'Supprimer cette classe ?',
    text: 'Cette action est irréversible.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Oui, supprimer',
    cancelButtonText: 'Annuler',
  });
  if (result.isConfirmed) {
    try {
      await classesService.delete(id);
      toast.success('Classe supprimée avec succès');
      refetch();
      Swal.fire('Supprimé !', 'La classe a été supprimée.', 'success');
    } catch (error) {
      toast.error('Erreur lors de la suppression');
    }
  }
};
const [editing, setEditing] = React.useState(null);
const [showModal, setShowModal] = React.useState(false);
const handleEdit = (classe) => {
  setEditing(classe);
  setShowModal(true);
};
  
  

const classesList = Array.isArray(classes?.data?.data) ? classes.data.data : (Array.isArray(classes?.data) ? classes.data : []);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Classes</h1>
        <ConditionalButton
          entity="classes"
          permission="create"
          onClick={() => { setEditing(null); setShowModal(true); }}
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
        >
          <FiPlus />
          <span>Nouvelle classe</span>
        </ConditionalButton>
      </div>

      <ResponsiveDataList
        isLoading={isLoading}
        isEmpty={classesList.length === 0}
        emptyMessage="Aucune classe trouvée"
        mobileCards={classesList.map((classe) => (
          <MobileCard
            key={classe.id}
            title={classe.classe}
            subtitle={classe.abrev}
            fields={[
              { label: 'Cycle', value: classe.cycle },
              { label: 'N° ordre', value: classe.num_ordre },
            ]}
            actions={
              <ConditionalActions
                entity="classes"
                onEdit={() => handleEdit(classe)}
                onDelete={() => handleDelete(classe.id)}
                editIcon={FiEdit}
                deleteIcon={FiTrash2}
                className="flex space-x-2"
              />
            }
          />
        ))}
      >
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Classe
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Abréviation
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Cycle
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  N° d'ordre
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {classesList.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                    Aucune classe trouvée
                  </td>
                </tr>
              ) : (
                classesList.map((classe) => (
                  <tr key={classe.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {classe.classe}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.abrev}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.cycle}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.num_ordre}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <ConditionalActions
                        entity="classes"
                        onEdit={() => handleEdit(classe)}
                        onDelete={() => handleDelete(classe.id)}
                        editIcon={FiEdit}
                        deleteIcon={FiTrash2}
                        className="flex space-x-2"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
      </ResponsiveDataList>
      {showModal && (
        <ClasseModal
          show={showModal}
          onClose={() => setShowModal(false)}
          editing={editing}
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default Classes;